import { createApp } from 'vue';
import delDiaChoice from '../../../vue/del-dia-choice/del-dia-choice.vue';

if (document.getElementById('vue-del-dia-choice')) {
  const props = {
    productID: document.getElementById('vue-del-dia-choice').dataset.id,
    productPronounce: productPronounce,
    comparePrice: comparePrice,
  };
  createApp(delDiaChoice, props).mount('#vue-del-dia-choice');
}
